import React, { useContext } from 'react'
import { ModalContext } from 'providers/Modal'
import modalStyles from 'styles/modal.module.scss'
import clsx from 'clsx'
import { ReactFinalFormContext } from 'react-final-form'
import { trackLinkClick } from 'tracking/loginEvents'

const SwitchTo = ({ styles }) => {
  const { setActive, setEmail } = useContext(ModalContext)
  const { getFieldState } = useContext(ReactFinalFormContext)

  const switchForm = formId => {
    setActive(formId)
    setEmail(getFieldState('email').value)
    trackLinkClick({
      fieldValue: 'Login',
    })
  }

  return (
    <p className={clsx(modalStyles.switcher, styles)}>
      Already a Member?{' '}
      <a
        data-testid="modal_login"
        href="javascript:void(0)"
        onClick={() => switchForm('login')}
      >
        Login
      </a>
    </p>
  )
}

export default SwitchTo
